import { useNavigate } from 'react-router'
import React from 'react'
import Psychology from '@mui/icons-material/Psychology'
import LocalHospital from '@mui/icons-material/LocalHospital'
import PersonAddAlt1 from '@mui/icons-material/PersonAddAlt1'
import PersonSearch from '@mui/icons-material/PersonSearch'
import GroupIcon from '@mui/icons-material/Group'
import MailOutline from '@mui/icons-material/MailOutline'
import Receipt from '@mui/icons-material/Receipt'
import CheckCircle from '@mui/icons-material/CheckCircle'
import PauseCircleOutline from '@mui/icons-material/PauseCircleOutline'
import History from '@mui/icons-material/History'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import {
  SupportHomePageContainer,
  SupportHomePageItem,
  TILE_COLORS,
  TileIconContainer,
  TileText,
} from 'src/supportPortal/views/home/styledComponents'
import useServerAuth from 'src/customHooks/useServerAuth'

export default function PractitionerManagementNavPage() {
  const navigate = useNavigate()
  const { allRolesInBoolean } = useServerAuth()
  
  return (
    <>
      <SupportHeader heading={'Practitioners & Service Providers'} showBackButton />
      <SupportHomePageContainer>
        {(allRolesInBoolean.isTherapistAdmin ||
          allRolesInBoolean.isClinicSuccessAdmin ||
          allRolesInBoolean.isAdmin) && (
          <>
            <SupportHomePageItem
              otherColor={TILE_COLORS.practitionerOnboarding}
              onClick={() => navigate('/support-home/practitioner-management/onboarding')}
            >
              <TileIconContainer>
                <PersonAddAlt1 />
              </TileIconContainer>
              <TileText>Practitioner Onboarding</TileText>
            </SupportHomePageItem>
            <SupportHomePageItem
              otherColor={TILE_COLORS.invitations}
              onClick={() => navigate('/support-home/practitioner-management/invitations')}
            >
              <TileIconContainer>
                <MailOutline />
              </TileIconContainer>
              <TileText>Invitations</TileText>
            </SupportHomePageItem>
            {/* Platform-wide practitioner enable/disable access log. */}
            <SupportHomePageItem
              otherColor={TILE_COLORS.accessLogs}
              onClick={() => navigate('/support-home/practitioner-management/access-logs')}
            >
              <TileIconContainer>
                <History />
              </TileIconContainer>
              <TileText>Access Logs</TileText>
            </SupportHomePageItem>
          </>
        )}
        {(allRolesInBoolean.isL1TherapySupport ||
          allRolesInBoolean.isL2TherapySupport ||
          allRolesInBoolean.isL3TherapySupport ||
          allRolesInBoolean.isTherapistAdmin) && (
          <>
            <SupportHomePageItem
              otherColor={TILE_COLORS.therapists}
              onClick={() => navigate('/support-home/practitioner-management/therapists')}
            >
              <TileIconContainer>
                <Psychology />
              </TileIconContainer>
              <TileText>Therapists</TileText>
            </SupportHomePageItem>
            <SupportHomePageItem
              otherColor={TILE_COLORS.applicants}
              onClick={() => navigate('/support-home/practitioner-management/applicants')}
            >
              <TileIconContainer>
                <PersonSearch />
              </TileIconContainer>
              <TileText>Applicants</TileText>
            </SupportHomePageItem>
            {/* Phase 14i — kyc-approved-but-disabled practitioners. They were invisible before;
                this tile gives the support team a single place to find and re-enable them. */}
            <SupportHomePageItem
              otherColor={TILE_COLORS.disabledPractitioners}
              onClick={() => navigate('/support-home/practitioner-management/disabled-practitioners')}
            >
              <TileIconContainer>
                <PauseCircleOutline />
              </TileIconContainer>
              <TileText>Disabled Practitioners</TileText>
            </SupportHomePageItem>
          </>
        )}
        {(allRolesInBoolean.isL1TherapySupport ||
          allRolesInBoolean.isL2TherapySupport ||
          allRolesInBoolean.isL3TherapySupport ||
          allRolesInBoolean.isTherapistAdmin ||
          allRolesInBoolean.isScreenerAdmin) && (
          <SupportHomePageItem
            otherColor={TILE_COLORS.screeners}
            onClick={() => navigate('/support-home/practitioner-management/screeners')}
          >
            <TileIconContainer>
              <GroupIcon />
            </TileIconContainer>
            <TileText>Screeners</TileText>
          </SupportHomePageItem>
        )}
        {(allRolesInBoolean.isClinicSuccessManager || allRolesInBoolean.isClinicSuccessAdmin) && (
          <SupportHomePageItem 
            otherColor={TILE_COLORS.doctors}
            onClick={() => navigate('/support-home/practitioner-management/doctors')}
          >
            <TileIconContainer>
              <LocalHospital />
            </TileIconContainer>
            <TileText>Doctors</TileText>
          </SupportHomePageItem>
        )}
        {allRolesInBoolean.isL3TherapySupport && (
          <SupportHomePageItem 
            otherColor={TILE_COLORS.payoutReceipts}
            onClick={() => navigate('/support-home/practitioner-management/payout-receipts')}
          >
            <TileIconContainer>
              <Receipt />
            </TileIconContainer>
            <TileText>Payout Receipts</TileText>
          </SupportHomePageItem>
        )}
        {(allRolesInBoolean.isL2TherapySupport ||
          allRolesInBoolean.isL3TherapySupport ||
          allRolesInBoolean.isClinicSuccessAdmin) && (
          <SupportHomePageItem 
            otherColor={TILE_COLORS.serviceApprovals}
            onClick={() => navigate('/support-home/practitioner-management/service-approvals')}
          >
            <TileIconContainer>
              <CheckCircle />
            </TileIconContainer>
            <TileText>Service Approvals</TileText>
          </SupportHomePageItem>
        )}
      </SupportHomePageContainer>
    </>
  )
}
